import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { PageHeaderStyles } from "@/components/styles/PageHeaderStyles";
import { EditUserForm } from "./EditUserForm";
export var CreateUser = function (_a) {
    var electionEventId = _a.electionEventId, close = _a.close, userAttributes = _a.userAttributes, rolesList = _a.rolesList;
    return (_jsx(PageHeaderStyles.Wrapper, { children: _jsx(EditUserForm, { rolesList: rolesList, userAttributes: userAttributes, close: close, createMode: true, electionEventId: electionEventId }) }));
};
